module.exports = __webpack_public_path__ + "static/media/notice-icon.890b128b.svg";